module.exports = __webpack_public_path__ + "web/img/logo (1).2d380d19.png";